import React from "react";
import "./style.scss";

const Esporte = () => <div>Esporte</div>;

export default Esporte;
